<template>
    <div class="header-top header-custom">
        <div class="container q-py-sm">
            <div class="row items-center justify-between">
                <router-link to="/">
                    <img src="../../img/identity/logo.png" :alt="appName" class="logo">
                </router-link>

                <div class="col-auto row items-center" v-if="0">
                    <q-btn no-caps dense flat rounded color="faded"
                           icon="person" class="account"
                           :label="$T('my account')">
                        <q-popover class="account">
                            <q-list separator class="q-pt-none">
                                <template v-if="user">
                                    <q-item v-close-overlay class="justify-center" link to="/profile">
                                        {{ $T('account settings') }}
                                    </q-item>
                                    <q-item v-close-overlay class="justify-center" link to="/favourites">
                                        {{ $T('favourites') }}
                                    </q-item>
                                    <q-item v-close-overlay class="justify-center" link to="/subscriptions">
                                        {{ $T('subscription') }}
                                    </q-item>

                                </template>


                                <q-item v-if="user">
                                    <div class="col q-pa-sm">
                                        <p class="q-mt-sm q-mb-md">{{$T("close your session")}}</p>
                                        <q-btn no-caps color="primary" link  @click.native="logout"
                                               v-close-overlay class="full-width super-hover"
                                               :label="$T('log out')"></q-btn>
                                    </div>
                                </q-item>

                                <!-- Guest -->
                                <q-item v-else>
                                    <div class="col q-pa-sm">
                                        <p class="q-mt-sm q-mb-md">{{$T("start your session")}}</p>
                                        <q-btn no-caps color="primary" v-close-overlay class="full-width super-hover"
                                               :label="$T('log in')" @click.prevent="$login()"></q-btn>
                                    </div>
                                </q-item>

                            </q-list>
                        </q-popover>
                    </q-btn>
                </div>
                <q-btn flat dense color="white" icon="menu"
                       @click="$emit('rightDrawerToogle')"></q-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {
        QBtn,
        QPopover,
        QList,
        QItem,
    } from 'quasar-framework'
    import md5 from 'md5'
    import Spinner from "./spinner/Spinner"

    export default {
        data: () => ({
            appName: window.config.appName
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),

            menus() {
                return window.config.menus
            }
        },

        components: {
            Spinner,
            QBtn,
            QPopover,
            QList,
            QItem,
        },

        methods: {
            md5,
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push({name: '/'})
                window.location.href = '/logout'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header.vue